<template>
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="form" class="toolbar">
        <el-form-item label="老人" required>
          <el-autocomplete v-model.trim="form.oldmanName" style="width:180px" :fetch-suggestions="queryOlder" @select="selectOld" @change="handleOldmanNameChange" />
        </el-form-item>
        <el-form-item label="日期范围" required>
          <el-date-picker v-model="form.dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="buildPreview">生成预览</el-button>
          <el-button type="info" plain icon="el-icon-download" @click="exportMd">导出 MD</el-button>
        </el-form-item>
      </el-form>
      <el-card v-loading="loading" shadow="never">
        <pre class="md-preview">{{ preview || '请选择老人与日期后生成报告' }}</pre>
      </el-card>
    </div>
  </div>
</template>
<script>
import { postDownload } from "@/utils/request.js";
export default {
  name: "NursingIntegrateReport",
  data() {
    return {
      form: { oldmanId: null, oldmanName: "", dateRange: null, reportType: 1 },
      _justSelected: false,
      _lastSuggestions: [],
      preview: "",
      loading: false
    };
  },
  methods: {
    queryOlder(q, cb) {
      if (!q) return cb([]);
      this.$postJson("omc/queryMachine/queryOldmanList", { oldName: q, pageNum: 1, pageSize: 20 }).then(res => {
        const list = (res.result && res.result.list) ? res.result.list : [];
        // 缓存搜索结果，用于精确匹配
        this._lastSuggestions = list;
        cb(list.map(o => ({ value: o.oldName, old: o })));
      });
    },
    selectOld(item) {
      this._justSelected = true;
      const o = item.old || item;
      this.form.oldmanId = o.oldmanId;
      this.form.oldmanName = o.oldName || item.value;
    },
    handleOldmanNameChange() {
      if (this._justSelected) {
        this._justSelected = false;
        return;
      }
      // 用户手动修改了输入框，清空 oldmanId，等待重新选中或精确匹配
      this.form.oldmanId = null;
    },
    // 解析 oldmanId：已有直接返回；否则按名字精确匹配缓存或重新查接口
    resolveOldmanId() {
      if (this.form.oldmanId) {
        return Promise.resolve(this.form.oldmanId);
      }
      const name = (this.form.oldmanName || '').trim();
      if (!name) {
        return Promise.resolve(null);
      }
      // 先从缓存里找精确匹配
      const cached = this._lastSuggestions.filter(o => o.oldName === name);
      if (cached.length === 1) {
        this.form.oldmanId = cached[0].oldmanId;
        return Promise.resolve(this.form.oldmanId);
      }
      // 缓存没有则重新查接口
      return this.$postJson("omc/queryMachine/queryOldmanList", { oldName: name, pageNum: 1, pageSize: 20 }).then(res => {
        const list = (res.result && res.result.list) ? res.result.list : [];
        this._lastSuggestions = list;
        const exact = list.filter(o => o.oldName === name);
        if (exact.length === 1) {
          this.form.oldmanId = exact[0].oldmanId;
          this.form.oldmanName = exact[0].oldName;
          return this.form.oldmanId;
        }
        return null;
      });
    },
    buildPayload() {
      if (!this.form.dateRange || this.form.dateRange.length !== 2) {
        this.$message.warning("请选择日期范围");
        return Promise.resolve(null);
      }
      return this.resolveOldmanId().then(id => {
        if (!id) {
          this.$message.warning("请选择老人");
          return null;
        }
        return {
          oldmanId: id,
          startDate: this.form.dateRange[0],
          endDate: this.form.dateRange[1],
          reportType: this.form.reportType
        };
      });
    },
    buildPreview() {
      this.buildPayload().then(p => {
        if (!p) return;
        this.loading = true;
        this.$postJson("omc/nursingIntegrate/buildMarkdown", p).then(res => {
          this.loading = false;
          if (res.code == 200) this.preview = res.result || "";
          else this.$message.error(res.message);
        }).catch(() => { this.loading = false; });
      });
    },
    exportMd() {
      this.buildPayload().then(p => {
        if (!p) return;
        postDownload("omc/nursingIntegrate/exportMd", "护理整合报告.md", p);
      });
    }
  },
  mounted() {}
};
</script>
<style scoped>
.md-preview {
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 14px;
  line-height: 1.7;
  min-height: 360px;
  margin: 0;
  font-family: Consolas, monospace;
}
</style>
